import * as React from "react";
export class FreeBetOption extends React.PureComponent {
    render() {
        return (React.createElement("option", { value: this.props.id, className: "rj-yourbet__free-bet-option", "data-uat": "free-bet-option" }, this.props.text));
    }
}
//# sourceMappingURL=FreeBetOption.js.map